{
  "version": 1,
  "asset_id": "b6b71651-a7bc-434f-820a-a1e1151fd4a1",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b6b71651-a7bc-434f-820a-a1e1151fd4a1/offer-overlay-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b6b71651-a7bc-434f-820a-a1e1151fd4a1/offer-overlay-320.webp",
  "original_filename": "offer-overlay-320.webp",
  "size": 21958,
  "content_type": "image/webp",
  "created_at": "2026-10-04T23:37:11Z"
}
